export default "<div class=\"page-not-found content text-center\">\n\n    <h1>404!</h1>\n    <h3>Page Not Found</h3>\n</div>"